import { RouteObject } from 'react-router-dom';
import NursLaw from '../components/pages/nurs/law/NursLaw';
import QiaifLaw from '../components/pages/qiaif/law/QiaifLaw';
import Act40Law from '../components/pages/act40/law/Act40Law';
import FivgLaw from '../components/pages/fivg/law/FivgLaw';
import PartiiLaw from '../components/pages/partii/law/PartiiLaw';
import CssfRiskSpreading from '../components/pages/sif-raif/cssfRiskSpreading/CssfRiskSpreading.component';
import StressScenarioPage from '../components/pages/ucits/stressTests/StressScenarioPage';
import PeStressScenario from '../components/pages/privateEquity/peStressScenarioTests/PeStressScenarioTests.component.tsx';
import PeValueAtRisk from '../components/pages/privateEquity/peValueAtRisk/PeValueAtRisk.component';
import HistoricalData from '../components/pages/ucits/historical/component';
import RiskComparison from '../components/pages/ucits/riskComparison/RiskComparisonPage';
import VarBacktest from '../components/pages/ucits/varBacktest/VarBackTestPage';
import SubFundSummaryPage from '../components/pages/utilities/SubFundSummary/SubFundSummaryPage';
import FailsPage from '../components/pages/utilities/Fails/FailsPage';
import AifmdReports from '../components/pages/aifmd/reports/component';
import Equity from '../components/pages/asset_class/equity/Equity';
import SyntheticRisk from '../components/pages/ucits/synthetic-risk/SyntheticRisk';
import MarketRisk from '../components/pages/ucits/market-risk-measurement/MarketRisk';
import SyntheticRiskShareClass from '../components/pages/ucits/syntheticRiskShareClass/SyntheticRiskShareClass';
import ShareClassHedgeData from '../components/pages/reportsPages/shareClassHedge/ShareClassHedgeData.component';
import Currency from '../components/pages/asset_class/currency/Currency';
import FixedIncome from '../components/pages/asset_class/fixedIncome/FixedIncome';
import Cis from '../components/pages/asset_class/cis/Cis';
import FundAssetLiquidationTime from '../components/pages/liquidity/fundAssetLiquidationTime/FundAssetLiquidationTimePage';
import LiquidityAdjustedSettlementDateAchievableBalancePage from '../components/pages/liquidity/lasdab/LiquidityAdjustedSettlementDateAchievableBalancePage';
import Moab from '../components/pages/liquidity/moab/component';
import RstFixed from '../components/pages/liquidity/rstFixed/RSTFixedPage';
import AifRstFixed from '../components/pages/aif_liquidity/rst-fixed/rst-fixed.component';
import RstVariable from '../components/pages/liquidity/rstVariable/component';
import LiquidationRiskOverview from '../components/pages/liquidity/liquidationRiskOverview/component';
import CounterpartyMarketLiquidityRiskPage from '../components/pages/liquidity/counterparty/CounterpartyMarketLiquidityRiskPage';
import RstEvolution from '../components/pages/liquidity/RstEvolution/component';
import ESGCompliance from '../components/pages/esg/esgExposure/Esg.component';
import SubscriptionsRedemptions from '../components/pages/ucits/subscriptionsRedemptions/SubscriptionsRedemptions';
import PeHeatMap from '../components/pages/privateEquity/peHeatMap/PeHeatMap.component';
import PeExposure from '../components/pages/privateEquity/peExposure/PeExposure.component';
import MarketLiquidityRisk from '../components/pages/liquidity/marketLiquidityRisk/MarketLiquidityRisk.component';
import VariableMarketVolumeLiquidationCosts from '../components/pages/liquidity/variableMarketVolumeLiquidationCosts/VariableMarketVolumeLiquidationCosts.component';
import PeLiquiidtyValueAtRisk from '../components/pages/privateEquity/peLiquidityValueAtRisk/PeLiquidityValueAtRisk.component';
import MonteCarloVar from '../components/pages/privateEquity/monteCarloVar/MonteCarloVar.componet';
import LiquidityDiscountAnalysis from '../components/pages/privateEquity/liquidityDiscountAnalysis/LiquidityDiscountAnalysis.component';
import DiscountCashflowConfiguration from '../components/pages/privateEquity/discountCashFlowConfiguration/DiscountCashFlowConfiguration.component';
import DiscountCashflowOverview from '../components/pages/privateEquity/discountCashflowOverview/DiscountCashflowOverview.component';
import PerformanceReport from '../components/pages/sharedComponents/performanceReport/PerformanceReport.component';
import CollateralMonitor from '../components/pages/ucits/collateralMonitor/CollateralMonitor.component';
import PerformanceDiagnostics from '../components/pages/performanceAttribution/performanceDiagnostics/PerformanceDiagnostics.component';
import SubFundPerformance from '../components/pages/performanceAttribution/subFundPerformance/SubFundPerformance.component.';
import AssetAllocationPerformance from '../components/pages/performanceAttribution/assetAllocationPerformance/AssetAllocationPerformance.component';
import AssetAndCurrency from '../components/pages/performanceAttribution/assetAndCurrency/AssetAndCurrency.component';
import SubFundCumulativeBreakdown from '../components/pages/performanceAttribution/subFundCumulativeBreakdown/SubFundCumulativeBreakdown.component';
import ExposureVsCumulativeReturns from '../components/pages/performanceAttribution/exposureVsCumulativeReturns/ExposureVsCumulativeReturns.component';
import SubFundHistorical from '../components/pages/performanceAttribution/subFundHistorical/SubFundHistorical.component';
import SubFundVsBenchmark from '../components/pages/performanceAttribution/subFundVsBenchmark/SubFundVsBenchmark.component';
import StockSelectionPerformance from '../components/pages/performanceAttribution/stockSelectionPerformance/StockSelectionPerformance.component';
import ESGPortfolioSummary from '../components/pages/esg/portfolioSummary/PortfolioSummary.component';
import ArticleScanner from '../components/pages/esg/articleScanner/ArticleScanner.component';
import PrincipleAdverseImpact from '../components/pages/esg/principleAdverseImpact/PrincipleAdverseImpact.component';
import PortfolioCarbonEmissions from '../components/pages/esg/portfolioCarbonEmissions/PortfolioCarbonEmissions.component';
import IndividualESGPage from '../components/pages/esg/individualESGPage/individualESGPage.component';
import ESGStressTests from '../components/pages/esg/esgStressTests/ESGStressTests.component';
import EsgVAR from '../components/pages/esg/esgVar/EsgVAR.component';
import IndicatorCompliance from '../components/pages/esg/indicatorCompliance/IndicatorCompliance.component';
import IndicatorCoverageRatioMonitor from '../components/pages/esg/IndicatorCoverageRatioMonitor/IndictaorCoverageRatioMonitor.component';
import EsAlignmentMonitor from '../components/pages/esg/esAlignmentMonitor/EsAlignmentMonitor.component';
import HistoricalDataExport from '../components/pages/manco/historicalDataExport/HistoricalDataExport.component';
import AlternativeNonCis from '../components/pages/asset_class/alternativeNonCis/AlternativeNonCis.component';
import PeProxyModel from '../components/pages/privateEquity/peProxyModel/PeProxyModel.component';
import RelativeRisk from '../components/pages/ucits/relativeRisk/RelativeRisk.component';
import CashflowStressTests from '../components/pages/privateEquity/cashFlowStressTests/CashFlowStressTests.component';
import FxRates from '../components/pages/utilities/fxRates/FxRates.component';
import RiaifLaw from '../components/pages/riaif/law/RiaifLaw';
import ESGExposure from '../components/pages/esg/exposure/ESGExposure.component';
import LiquidityRiskEvolutionPage from '../components/pages/liquidity/riskEvolution/LiquidityRiskEvolutionPage';
import LiquidityModelBreakdown from '../components/pages/liquidity/liquidityModelBreakdown/LiquidityModelBreakdown.page';
import LiquidityModelEvolution from '../components/pages/liquidity/liquidityModelEvolution/liquidityModelEvolution.page';
import { FundRoutePaths } from './page-routes';
import MoneyMarketMonitorPage from '../components/pages/moneyMarketMonitor/MoneyMarketMonitorPage';
import NavReconShareClassesPage from '../components/pages/navRecon/shareClasses/NavReconShareClassesPage';
import NavReconPositionsPage from '../components/pages/navRecon/positions/NavReconPositionsPage';
import { FundInfoComponentProps, SimpleGeneralPageWrapper } from '../components/layout/general/SimpleGeneralPageWrapper';
import PositionUpdatePortal from '../components/pages/manco/positionUpdatePortal/PositionUpdatePortal.page';
import CounterpartyPage from '../components/pages/ucits/counterparty/CounterpartyPage';

const FundRoutes = (data: any): RouteObject[] => [
  {
    path: FundRoutePaths.NURS_LAW,
    element: (
      <SimpleGeneralPageWrapper pageId={'nurs-law'} requireFundSelection>
        <NursLaw {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },

  {
    path: FundRoutePaths.QIAIF_LAW,
    element: (
      <SimpleGeneralPageWrapper pageId={'qiaif-law'} requireFundSelection>
        <QiaifLaw {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.RIAIF_LAW,
    element: (
      <SimpleGeneralPageWrapper pageId={'riaif-law'} requireFundSelection>
        <RiaifLaw {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ACT40_LAW,
    element: (
      <SimpleGeneralPageWrapper pageId={'act40-law'} requireFundSelection>
        <Act40Law {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.FIVG_LAW,
    element: (
      <SimpleGeneralPageWrapper pageId={'fivg-law'} requireFundSelection>
        <FivgLaw {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PARTII_LAW,
    element: (
      <SimpleGeneralPageWrapper pageId={'partii-law'} requireFundSelection>
        <PartiiLaw {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },

  {
    path: FundRoutePaths.CSSF_RISK_SPREADING,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'cssf-risk-spreading'}
        requireFundSelection
      >
        <CssfRiskSpreading {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.COUNTERPARTY,
    element: (
      <SimpleGeneralPageWrapper pageId={'counterparty'} requireFundSelection>
        <CounterpartyPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.STRESS_SCENARIO_TESTS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'stress-scenario-tests'}
        requireFundSelection
      >
        <StressScenarioPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_STRESS_SCENARIO_TESTS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'pe-stress-scenario-tests'}
        requireFundSelection
      >
        <PeStressScenario {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_VALUE_AT_RISK,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'pe-value-at-risk'}
        requireFundSelection
      >
        <PeValueAtRisk {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.HISTORICAL_DATA,
    element: (
      <SimpleGeneralPageWrapper pageId={'historical-data'} requireFundSelection>
        <HistoricalData {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.RISK_COMPARISON,
    element: (
      <SimpleGeneralPageWrapper pageId={'risk-comparison'} requireFundSelection>
        <RiskComparison {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.VAR_BACKTEST,
    element: (
      <SimpleGeneralPageWrapper pageId={'var-backtest'} requireFundSelection>
        <VarBacktest {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SUB_FUND_SETUP,
    element: (
      <SimpleGeneralPageWrapper pageId={'sub-fund-setup'} requireFundSelection>
        <SubFundSummaryPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.FAILS,
    element: (
      <SimpleGeneralPageWrapper pageId={'fails'} requireFundSelection>
        <FailsPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.AIFMD_REPORTS,
    element: (
      <SimpleGeneralPageWrapper pageId={'aifmd-reports'} requireFundSelection>
        <AifmdReports {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.EQUITY,
    element: (
      <SimpleGeneralPageWrapper pageId={'equity'} requireFundSelection>
        <Equity {...({} as FundInfoComponentProps)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SRRI,
    element: (
      <SimpleGeneralPageWrapper pageId={'srri'} requireFundSelection>
        <SyntheticRisk {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.MARKET_RISK_MEASUREMENT,
    element: (
      <SimpleGeneralPageWrapper pageId={'mrm'} requireFundSelection>
        <MarketRisk {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SRRI_SHARE_CLASS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'srri-share-class'}
        requireFundSelection
      >
        <SyntheticRiskShareClass {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SHARE_CLASS_HEDGE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'share-class-hedge'}
        requireFundSelection
      >
        <ShareClassHedgeData {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.CURRENCY,
    element: (
      <SimpleGeneralPageWrapper pageId={'currency'} requireFundSelection>
        <Currency {...({} as FundInfoComponentProps)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.FIXED_INCOME,
    element: (
      <SimpleGeneralPageWrapper pageId={'fixed-income'} requireFundSelection>
        <FixedIncome {...({} as FundInfoComponentProps)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.CIS,
    element: (
      <SimpleGeneralPageWrapper pageId={'cis'} requireFundSelection>
        <Cis {...({} as FundInfoComponentProps)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.FUND_ASSET_LIQUIDATION_TIME,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'fund-asset-liquidation-time'}
        requireFundSelection
      >
        <FundAssetLiquidationTime {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.LASDAB,
    element: (
      <SimpleGeneralPageWrapper pageId={'lasdab'} requireFundSelection>
        <LiquidityAdjustedSettlementDateAchievableBalancePage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.MOAB,
    element: (
      <SimpleGeneralPageWrapper pageId={'moab'} requireFundSelection>
        <Moab {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.RST_FIXED,
    element: (
      <SimpleGeneralPageWrapper pageId={'rst-fixed'} requireFundSelection>
        <RstFixed {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.AIFMD_RST_FIXED,
    element: (
      <SimpleGeneralPageWrapper pageId={'aifmd-rst-fixed'} requireFundSelection>
        <AifRstFixed {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.RST_VARIABLE,
    element: (
      <SimpleGeneralPageWrapper pageId={'rst-variable'} requireFundSelection>
        <RstVariable {...({} as FundInfoComponentProps)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.LIQUIDATION_RISK_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'liquidation-risk-overview'}
        requireFundSelection
      >
        <LiquidationRiskOverview {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.COUNTERPARTY_MARKET_LIQUIDITY_RISK,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'counterparty-market-liquidity-risk'}
        requireFundSelection
      >
        <CounterpartyMarketLiquidityRiskPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.LIQUIDITY_RISK_EVOLUTION,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'liquidity-risk-evolution'}
        requireFundSelection
      >
        <LiquidityRiskEvolutionPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.REVERSE_STRESS_TEST_EVOLUTION,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'reverse-stress-test-evolution'}
        requireFundSelection
      >
        <RstEvolution {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ESG,
    element: (
      <SimpleGeneralPageWrapper pageId={'esg'} requireFundSelection>
        <ESGCompliance {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SUBSCRIPTIONS_REDEMPTIONS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'subscriptions-redemptions'}
        requireFundSelection
      >
        <SubscriptionsRedemptions {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_HEAT_MAP,
    element: (
      <SimpleGeneralPageWrapper pageId={'pe-heat-map'} requireFundSelection>
        <PeHeatMap {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_EXPOSURE,
    element: (
      <SimpleGeneralPageWrapper pageId={'pe-exposure'} requireFundSelection>
        <PeExposure {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.MARKET_LIQUIDITY_RISK,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'market-liquidity-risk'}
        requireFundSelection
      >
        <MarketLiquidityRisk {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.VARIABLE_MARKET_VOLUME_LIQUIDATION_COSTS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'variable-market-volume-liquidation-costs'}
        requireFundSelection
      >
        <VariableMarketVolumeLiquidationCosts {...({} as FundInfoComponentProps)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.LIQUIDITY_PE_VALUE_AT_RISK,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'liquidity-pe-value-at-risk'}
        requireFundSelection
      >
        <PeLiquiidtyValueAtRisk {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_MONTE_CARLO_VAR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'pe-monte-carlo-var'}
        requireFundSelection
      >
        <MonteCarloVar {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_LIQUIDITY_DISCOUNT_ANALYSIS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'pe-liquidity-discount-analysis'}
        requireFundSelection
      >
        <LiquidityDiscountAnalysis {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.DISCOUNT_CASHFLOW_CONFIGURATION,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'discount-cashflow-configuration'}
        requireFundSelection
      >
        <DiscountCashflowConfiguration {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.DISCOUNT_CASHFLOW_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'discount-cashflow-overview'}
        requireFundSelection
      >
        <DiscountCashflowOverview {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PERFORMANCE_REPORT,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'performance-report'}
        requireFundSelection
      >
        <PerformanceReport {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.COLLATERAL_MONITOR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'collateral-monitor'}
        requireFundSelection
      >
        <CollateralMonitor {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PERFORMANCE_DIAGNOSTICS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'performance-diagnostics'}
        requireFundSelection
      >
        <PerformanceDiagnostics {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SUB_FUND_PERFORMANCE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'sub-fund-performance'}
        requireFundSelection
      >
        <SubFundPerformance {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ASSET_ALLOCATION_PERFORMANCE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'asset-allocation-performance'}
        requireFundSelection
      >
        <AssetAllocationPerformance {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ASSET_AND_CURRENCY,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'asset-and-currency'}
        requireFundSelection
      >
        <AssetAndCurrency {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SUB_FUND_CUMULATIVE_BREAKDOWN,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'sub-fund-cumulative-breakdown'}
        requireFundSelection
      >
        <SubFundCumulativeBreakdown {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.INITIAL_EXPOSURE_VS_CUMULATIVE_RETURNS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'initial-exposure-vs-cumulative-returns'}
        requireFundSelection
      >
        <ExposureVsCumulativeReturns {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SUB_FUND_HISTORICAL_PERFORMANCE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'sub-fund-historical-performance'}
        requireFundSelection
      >
        <SubFundHistorical {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SUB_FUND_VS_BENCHMARK,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'sub-fund-vs-benchmark'}
        requireFundSelection
      >
        <SubFundVsBenchmark {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.STOCK_SELECTION_PERFORMANCE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'stock-selection-performance'}
        requireFundSelection
      >
        <StockSelectionPerformance {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PORTFOLIO_ESG,
    element: (
      <SimpleGeneralPageWrapper pageId={'portfolio-esg'} requireFundSelection>
        <ESGPortfolioSummary {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ARTICLE_SCANNER,
    element: (
      <SimpleGeneralPageWrapper pageId={'article-scanner'} requireFundSelection>
        <ArticleScanner {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PRINCIPLE_ADVERSE_IMPACT,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'principle-adverse-impact'}
        requireFundSelection
      >
        <PrincipleAdverseImpact {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.CARBON_EMISSIONS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'carbon-emissions'}
        requireFundSelection
      >
        <PortfolioCarbonEmissions {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ESG_EXPOSURE,
    element: (
      <SimpleGeneralPageWrapper pageId={'esg-exposure'} requireFundSelection>
        <ESGExposure {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ENVIRONMENTAL_ESG,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'environmental-esg'}
        requireFundSelection
      >
        <IndividualESGPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.SOCIAL_ESG,
    element: (
      <SimpleGeneralPageWrapper pageId={'social-esg'} requireFundSelection>
        <IndividualESGPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.CORPORATE_GOVERNANCE_ESG,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'corporate-governance-esg'}
        requireFundSelection
      >
        <IndividualESGPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ESG_STRESS_TESTS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'esg-stress-tests'}
        requireFundSelection
      >
        <ESGStressTests {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ESG_VAR,
    element: (
      <SimpleGeneralPageWrapper pageId={'esg-var'} requireFundSelection>
        <EsgVAR {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.INDICATOR_COMPLIANCE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'indicator-compliance'}
        requireFundSelection
      >
        <IndicatorCompliance {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.INDICATOR_COVERAGE_RATIO_MONITOR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'indicator-coverage-ratio-monitor'}
        requireFundSelection
      >
        <IndicatorCoverageRatioMonitor {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ES_ALIGNMENT_MONITOR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'es-alignment-monitor'}
        requireFundSelection
      >
        <EsAlignmentMonitor {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.HISTORICAL_DATA_EXPORT,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'historical-data-export'}
        requireFundSelection
      >
        <HistoricalDataExport {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.ALTERNATIVE_NON_CIS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'alternative-non-cis'}
        requireFundSelection
      >
        <AlternativeNonCis {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.PE_PROXY_MODEL,
    element: (
      <SimpleGeneralPageWrapper pageId={'pe-proxy-model'} requireFundSelection>
        <PeProxyModel {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.RELATIVE_RISK,
    element: (
      <SimpleGeneralPageWrapper pageId={'relative-risk'} requireFundSelection>
        <RelativeRisk {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.CASHFLOW_STRESS_TESTS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'cashflow-stress-tests'}
        requireFundSelection
      >
        <CashflowStressTests {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.FX_RATES,
    element: (
      <SimpleGeneralPageWrapper pageId={'fx-rates'} requireFundSelection>
        <FxRates {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.MONEY_MARKET_FUND_MONITOR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'money-market-fund-monitor'}
        requireFundSelection
      >
        <MoneyMarketMonitorPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.NAV_RECON_SHARE_CLASSES,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'nav-recon-share-classes'}
        requireFundSelection
      >
        <NavReconShareClassesPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.NAV_RECON_POSITIONS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'nav-recon-positions'}
        requireFundSelection
      >
        <NavReconPositionsPage {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.POSITION_UPDATE_PORTAL,
    element: (
      <SimpleGeneralPageWrapper
        pageId="position-update-portal"
        requireFundSelection
      >
        <PositionUpdatePortal {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.LIQUIDITY_MODEL_BREAKDOWN,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'liquidity-model-breakdown'}
        requireFundSelection
      >
        <LiquidityModelBreakdown {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
  {
    path: FundRoutePaths.LIQUIDITY_MODEL_EVOLUTION,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'liquidity-model-evolution'}
        requireFundSelection
      >
        <LiquidityModelEvolution {...({} as any)} />
      </SimpleGeneralPageWrapper>
    ),
  },
];

export default FundRoutes;
